import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';

import BaseButton from 'features/app/components/BaseButton';
import { useTranslation } from 'hooks/useTranslation';
import { useStyles } from 'features/users/components/ShareBalanceStep/styles';
import { formatCurrencyNumber } from 'features/app/utils/formatCurrencyNumber';

type ShareBalanceStepProps = {
  availableBalance: number;
  handleSumbit: () => void;
  currency: string;
  amount: number;
};

export const ShareBalanceStep: React.FC<ShareBalanceStepProps> = ({
  availableBalance,
  handleSumbit,
  currency,
  amount,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('users');

  return (
    <>
      <Typography variant="h1" className={classes.heading}>
        {t('shareBalanceStep.heading')}
      </Typography>

      <Box className={classes.preview}>
        <Box className={classes.item}>
          <Typography className={classes.text}>{t('shareBalanceStep.availableBalance')}</Typography>
          <Typography className={clsx(classes.text, classes.textMedium)}>
            {formatCurrencyNumber(availableBalance)} {currency}
          </Typography>
        </Box>

        <Box className={classes.item}>
          <Typography className={classes.text}>{t('shareBalanceStep.amount')}</Typography>
          <Typography className={clsx(classes.text, classes.textMuted)}>
            - {formatCurrencyNumber(amount)} {currency}
          </Typography>
        </Box>

        <Box className={classes.divider} />

        <Box className={classes.item}>
          <Typography className={classes.text}>{t('shareBalanceStep.remaining')}</Typography>
          <Typography className={clsx(classes.text, classes.textMedium)}>
            {formatCurrencyNumber(availableBalance - amount)} {currency}
          </Typography>
        </Box>
      </Box>

      <BaseButton className={classes.button} labelClass={classes.buttonLabel} onClick={handleSumbit}>
        {t('shareBalance.shareStepButton')}
      </BaseButton>
    </>
  );
};
